<template>
  <div class="pages">
    <!--顶部头像-->
    <div class="headerInfo">
      <img class="headBack" src="../static/images/main/banner_null.png" width="100%"/>
      <div class="backView">
        <span class="Back" @click="back()">返回</span>
        <span class="Record" @click="toRecord()">推荐记录</span>
      </div>
      <div class="userInfo">
        <img v-if="user.Sex == '男'" :src="user.Head != ''?user.Head:headImgUrl" class="round_icon"
             :style="{border:'solid 2px #AACC03'}">
        <img v-if="user.Sex == '女'" :src="user.Head != ''?user.Head:headImgUrl" class="round_icon"
             :style="{border:'solid 2px #E75296'}">
        <span>{{ user.Name }}</span>
      </div>
    </div>
    <div class="info">
      <ul>
        <li>
          <em>{{ user.Height }}</em>
          <span>身高cm</span>
        </li>
        <li>
          <em>{{ user.Age }}</em>
          <span>年龄</span>
        </li>
        <li>
          <em>{{ user.Weight }}</em>
          <span>体重kg</span>
        </li>
        <li>
          <em>{{ user.Sex }}</em>
          <span>性别</span>
        </li>
      </ul>
    </div>

    <div class="fitnessRecord">
      <div class="title">
        课程推荐
      </div>
      <ul class="recordEmpty" v-if="TTdStaticsInfo.length < 0">
        推荐记录空...
      </ul>

      <!--会员卡信息-->
      <div class="value" style="margin-top: 20px">
        <em class="expire"> 起止日期 {{ TToStaticsInfo.TtoBT | filterTime }}
          至 {{ TToStaticsInfo.TtoET | filterTime }} </em>
        <div class="vTitle left">
          完成
          <span> {{ TToStaticsInfo.SumFinishNumb }} </span>
          节课
        </div>
        <div class="vTitle right">
          目标
          <span> {{ TToStaticsInfo.SumTargetNumb }} </span>
          节课
        </div>
        <mu-flex class="linear-progress">
          <mu-linear-progress mode="determinate"
                              :value="classFinish / classTotal * 100"
                              :size="10"
                              color="secondary"/>
        </mu-flex>
      </div>

      <ul class="record">
        <li v-for="item in TTdStaticsInfo">
          <div class="column1"><i></i></div>
          <div class="column2">
            <div>
              <span>{{ item.ClassName }}</span>
            </div>
            <div>
              <em>目标 {{ item.SumTargetNumb }} 节课
                完成 {{ item.SumFinishNumb }} 节课</em>
            </div>
          </div>
          <div class="column3" v-if="item.SumTargetNumb - item.SumFinishNumb >= 0" >
            <img v-for="count in item.SumFinishNumb" src="../../src/static/images/comm/icon_light_on.png"/>
            <img v-for="count in (item.SumTargetNumb - item.SumFinishNumb)" src="../../src/static/images/comm/icon_light_off.png"/>
          </div>
        </li>
      </ul>
    </div>

    <!--底部课程统计-->
    <bottomTab :curTab="thisTab"/>
  </div>
</template>

<script>
import axios from 'axios';
import bottomTab from '../components/bottomTab'
import {
  VipUserSelfQuery,
  PersonTtdStaticsQuery,
} from '../api/getApiRes.js'

let qs = require('qs');
import Global from '../Global.js'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
// 引入提示框和title组件
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/dataZoom')
require('echarts/lib/component/legend')
require('echarts/lib/component/grid')

export default {
  data() {
    return {
      viewType:'',
      ttoId: '',
      userMd5: '',
      thisTab: '我的运动',
      screenWidth: document.body.clientWidth + 'px',
      headImgUrl: require('../static/images/mine/header_default.png'),
      TTdStaticsInfo: [],
      TToStaticsInfo: {},
      classFinish: 0,
      classTotal: 0,
      user: {
        Name: '',
        Age: '',
        Height: '',
        Weight: '',
        StaticHr: '',
        Phone: '',
        Sex: '',
        Head: '',
      }
    }
  },
  watch: {
    '$route'(to) {
      if (to.name == 'lessonRecommendDetail') {
        let that = this;
        that.ttoId = that.$route.query.ttoId;
        that.viewType = that.$route.query.viewType;
        that.getUserInfo();//获取用户基本信息
        that.getRecommendDetail();//获取测评记录
      }
    },
  },
  mounted() {
    let that = this;
    that.ttoId = this.$route.query.ttoId;
    that.viewType = that.$route.query.viewType;
    that.getUserInfo();//获取用户基本信息
    that.getRecommendDetail();//获取测评记录
  },
  methods: {
    //返回上一页
    back() {
      if(this.viewType == 1){
        this.$router.push({path: '/report'});
      }else{
        this.$router.push({path: '/lessonRecommendRecord'});
      }
    },
    //返回到结果集
    toRecord() {
        this.$router.push({path: '/lessonRecommendRecord'});
    },
    //获取用户基本信息
    getUserInfo() {
      let that = this;
      let param = {
        token: localStorage.token
      };
      let postData = qs.stringify(param);
      VipUserSelfQuery(postData).then(res => {
        let json = res;
        if (json.Code == 0) {
          that.user = json.Rs;
          that.userMd5 = json.Rs.UserMd5;
        } else {
          that.$toast.message(json.Memo);
        }
      })
    },
    //获取课程评分信息
    getRecommendDetail() {
      let that = this;
      let param = {
        token: localStorage.token,
        ttoId: that.ttoId
      };
      let postData = qs.stringify(param);
      PersonTtdStaticsQuery(postData).then(res => {
        let json = res;
        if (json.Code == 0) {
          if (json.TTdStaticsInfo != null) {
            that.TTdStaticsInfo = json.TTdStaticsInfo;
            that.TToStaticsInfo = json.TToStaticsInfo;
            that.classFinish = that.TToStaticsInfo.SumFinishNumb;
            that.classTotal = that.TToStaticsInfo.SumTargetNumb;
          }
          if (json.TToStaticsInfo != null) {
            that.TToStaticsInfo = json.TToStaticsInfo;
          }
        } else {
          that.TTdStaticsInfo = [];
          that.TToStaticsInfo = [];
          // that.$toast.message(json.Memo);
        }
      })
    },
    //查看体测详情
    toFitnessDetail(fitnessItem) {
      this.$router.push({
        path: '/fitnessDetail',
        query: {
          shopName: fitnessItem.ShopName,
          ftoId: fitnessItem.FtoId,
          fitName: fitnessItem.FtoName,
          fitTime: fitnessItem.CreatedAt
        }
      });
    }
  },
  filters: {
    hidePhone: function (val) {
      let str = String(val)
      let len = str.length;
      if (len >= 7) {
        let reg = str.slice(-8, -4)
        return str.replace(reg, "****")
      } else if (len < 7 && len >= 6) {
        let reg = str.slice(-4, -2)
        return str.replace(reg, "**")
      }
    },
    filterTime: function (value) {
      if (!value) {
        return 0;
      } else {
        return dateFormatWithoutZone(value, 16);
      }
    },
    fmtTime: function (value) {
      if (!value) {
        return 0
      } else {
        // js默认使用毫秒
        value = value * 1000
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // A跳转到B，B页面停留在A页面的滚动位置；解决方法：将scrollTop设置为0
    next(vm => {
      //因为当钩子执行前，组件实例还没被创建
      // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
      if (to.name == 'reportLessonDetail') {
        vm.getUserInfo();
      }
    });
  },
  components: {
    bottomTab
  }
}
</script>

<style scoped>
.pages {
  overflow: hidden;
  display: block;
  margin: 0 auto;
  background: #F2F2F2;
}

.headerInfo {
  position: relative;
}

.headerInfo .headBack {
  height: 120px;
  position: absolute;
  z-index: 1;
}

.headerInfo .backView {
  left: 5%;
  width: 90%;
  top: 1.5rem;
  position: absolute;
  z-index: 2;
  text-align: center;
}

.headerInfo .Back {
  width: 50px;
  height: 25px;
  font-size: 14px;
  border-radius: 2px;
  line-height: 26px;
  float: left;
  color: #F4F4F4;
  display: block;
  margin-top: 60px;
  background: rgba(255, 255, 255, 0.24);
  text-align: center;
}

.headerInfo .Record {
  width: 70px;
  height: 25px;
  float: right;
  font-size: 14px;
  border-radius: 2px;
  line-height: 26px;
  color: #FFE58D;
  display: block;
  margin-top: 60px;
  margin-left: 110px;
  background: rgba(255, 255, 255, 0.24);
  text-align: center;
}

.headerInfo .userInfo {
  left: 42%;
  top: 1.25rem;
  position: absolute;
  z-index: 2;
  text-align: center;
}

.headerInfo .userInfo span {
  font-size: 16px;
  color: white;
  display: block;
  margin-top: 5px;
}

.round_icon {
  width: 64px;
  height: 64px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 3px;
  border: solid 2px white;
}

.info {
  background: #fff;
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 120px auto 0;
}

.info ul {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 10px auto;
}

.info li {
  width: 25%;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
  float: left;
  text-align: center;
}

.info li:nth-child(2) {
  border-color: #e2e2e2;
}

.info li:nth-child(3) {
  border-color: #e2e2e2;
  border-left: 0;
}

.info li em {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  color: #363636;
  font-size: 20px;
  text-align: center;
}

.info li span {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  color: #c4c4c4;
  font-size: 12px;
  text-align: center;
}

.fitnessRecord {
  height: 600px;
  margin-top: 10px;
}

.fitnessRecord .title {
  height: 60px;
  font-size: 16px;
  color: #E75296;
  font-weight: bold;
  line-height: 60px;
  text-align: center;
  background: #FFFFFF;
}

.fitnessRecord .recordEmpty {
  height: 200px;
  line-height: 100px;
  text-align: center;
  font-weight: normal;
  font-size: 16px;
}

.value {
  width: 100%;
  height: 131px;
  background: #fff;
  padding: 13px 0;
}

.value .vTitle {
  width: 100%;
  display: block;
  text-align: left;
  margin-left: 25px;
  font-family: "PingFang SC";
  font-weight: 300;
  font-size: 15px;
}

.value .expire {
  text-align: center;
  font-size: 14px;
  display: block;
  color: #4E4E4E;
}

.vTitle.left {
  width: 30%;
  margin-top: 12px;
  color: #E75296;
  float: left;
}

.vTitle.left span {
  font-size: 22px;
  font-weight: bold;
  color: #E75296;
}

.vTitle.right {
  width: 30%;
  margin-top: 12px;
  color: #37CB00;
  float: right;
}

.vTitle.right span {
  color: black;
  font-size: 22px;
  font-weight: bold;
  color: #37CB00;
}


/deep/ .linear-progress {
  width: 90%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  border-radius: 250px;
}

.fitnessRecord .record {
  padding-bottom: 15px;
  padding-top: 5px;
  background: #FFFFFF;
}

.fitnessRecord .record li {
  background: #F7FFF4;
  height: 56px;
  width: 95%;
  margin: 10px auto 0;
  border-radius: 8px;
  border: 1px solid #DDEFD6;
}

.record li .column1 {
  float: left;
}

.record li .column1 i {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background: #37CB00;
  margin-left: 10px;
  margin-top: 20px;
}

.record li .column2 {
  float: left;
  height: 56px;
  margin-left: 10px;
  display: block;
}

.record li .column2 span {
  margin-top: 8px;
  display: block;
  font-size: 14px;
}

.record li .column2 em {
  font-size: 12px;
  color: #909090;
}

.record li .column3 {
  float: right;
  height: 56px;
  margin-right: 20px;
  display: block;
}

.record li .column3 img {
  margin-top: 12px;
  margin-left: 3px;
}


/deep/ .mu-warning-text-color {
  float: left;
}

@media only screen and (max-width: 640px) {

}

@media only screen and (max-width: 480px) {

}

@media only screen and (max-width: 375px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 320px) {

}

@media only screen and (min-width: 641px) {

}
</style>
